module.exports = __webpack_public_path__ + "static/5-e140a3df17d0fdd581f11216525d8318.jpg";